<template lang="pug">
  li.NotificationsListItem.notification-item(
    :id="id",
    :class="{ 'is-new': !isRead, 'is-setting-as-read': settingAsRead }",
    @click="onClick"
  )
    .notification-item-icon
      .notification-item-icon__wrap
        NotificationsListItemIcon(:type="type" :code="code")
    .notification-item-content
      .notification-item-content__status(@click.prevent="setAsRead")
        BaseTooltip(
          content-class="general-tooltip notification-tooltip",
          :content-height="40",
          v-bind="$attrs",
        )
          span(slot="activator")
            .notification-item-content__status--mark
          span Mark as Read
      BaseMarkdown.notification-item-content__text(
        :text="text",
        v-improve-links
      )
      p.notification-item-content__time.small-text
        span.date(v-if="!isRead") {{ time | short-date }}
        span.time {{ get12HoursTimeFromString(localTime) }}
</template>

<script>
import {
  getDatesDiff,
  get12HoursTimeFromString,
} from 'Utils/time';
import bankAccountMixin from 'Mixins/bankAccountMixin';
import BaseMarkdown from 'Components/Base/BaseMarkdown';
import NotificationsListItemIcon from './NotificationsListItemIcon';

export default {
  name: 'NotificationsListItem',
  components: { BaseMarkdown, NotificationsListItemIcon },
  mixins: [bankAccountMixin],
  props: {
    message: Object,
    time: String,
    id: Number,
    read_flag: Boolean,
    channel: String,
  },
  data() {
    return {
      lifetime: getDatesDiff(this.time, new Date()),
      intervalId: null,
      settingAsRead: false,
    };
  },
  computed: {
    isRead() {
      return this.read_flag;
    },
    type() {
      return this.message ? this.message.type : '';
    },
    code() {
      return this.message ? this.message.code : '';
    },
    text() {
      if (!this.message) return '';
      const text = this.message.text.replace(/(funding|active|exited)#id-(?!(funding|active|exited)-)/, '$1#id-$1-');
      return this.$_bankAccount_getClearedOfInsIdText(text);
    },
    localTime() {
      return new Date(this.time).toString();
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  created() {
    this.setDurationInterval();
  },
  methods: {
    get12HoursTimeFromString,
    onClick(e) {
      // if click inside item on link - set as read
      if (e.target && e.target.nodeName === 'A') this.setAsRead();
    },
    setAsRead() {
      this.settingAsRead = true;
      setTimeout(() => {
        this.$emit('read', this.id);
      }, 1000);
    },
    setLifeTime() {
      this.lifetime = getDatesDiff(this.time, new Date());
    },
    setDurationInterval() {
      this.intervalId = setInterval(() => {
        this.setLifeTime();
      }, 10000);
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.notification-item
  width: 100%
  position: relative
  z-index: 1
  display: flex
  flex-direction: row
  align-items: center
  // margin-bottom: 65px
  padding: 10px 0
  &:before
    content: ''
    position: absolute
    z-index: 1
    left: 17px
    top: 0
    width: 1px
    height: 100%
    background-color: $support_lightgray
  &-icon
    width: 35px
    height: 35px
    position: relative
    flex-shrink: 0
    margin-right: 30px
    @media screen and (max-width: 767px)
      margin-right: 10px
    &__wrap
      width: 35px
      height: 35px
      background-color: $white
      border-radius: 100%
      display: flex
      align-items: center
      justify-content: center
      position: relative
      z-index: 2
      box-shadow: 0 2px 5px 0 rgba(0,0,0,0.02)
    &:before
      content: ''
      position: absolute
      z-index: 1
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      width: calc(100% + 15px)
      height: calc(100% + 15px)
      background-color: #FBFBFB
      border-radius: 100%
  &-content
    background: $white
    border: 1px solid $support_lightgray
    border-radius: 2px
    width: 100%
    padding: 20px 40px
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    ::v-deep strong
      +font(600)
    @media screen and (max-width: 767px)
      flex-direction: column
      align-items: flex-start
      padding: 10px
      ::v-deep p
        font-family: $font-medium
        font-weight: 500
        font-size: 12px
        line-height: 19px
        a
          font-size: 12px
          line-height: 19px
          font-weight: 600
          font-family: $font-semibold
    &__time
      flex-shrink: 0
      margin-bottom: 0
      margin-left: 50px
      @media screen and (max-width: 767px)
        margin-left: 0
        margin-top: 5px
      display: flex
      flex-direction: column
      text-align: right
      @media screen and (max-width: 767px)
        flex-direction: row
      .date
        font-family: $font-semibold
        @media screen and (max-width: 767px)
          margin-right: 5px
    &__status
      width: 33px
      height: 33px
      position: absolute
      right: 0px
      top: 9px
      display: flex
      align-items: center
      justify-content: center
      outline: none
      @media screen and (max-width: 767px)
        top: auto
        bottom: 12px
        right: 1px
      &--mark
        width: 7px
        height: 7px
        border-radius: 100%
        position: relative
        outline: none
        background-color: transparent
      ::v-deep .v-tooltip-activator
        border-bottom: none
        outline: none
        width: 33px
        height: 33px
        display: flex
        align-items: center
        justify-content: center
        pointer-events: none
    &__text
      display: flex
      flex-direction: row
      width: 100%
    ::v-deep a
      position: relative
      display: inline
      z-index: 1
      +mt(.3s)
      color: inherit
      line-height: 20px
      font-family: $font-semibold
      border-bottom: solid 2px $support_yellow
      &:hover
        +mt(.3s)
        border-bottom: solid 2px transparent
    ::v-deep p
      margin-bottom: 0
      strong
        +font(600)
  &.is-new
    .notification-item-content
      box-shadow: 0 2px 15px 0 rgba(0,0,0,0.05)
    .notification-item-content__status
      &--mark
        background-color: $secondary
      ::v-deep .v-tooltip-activator
        pointer-events: auto
        cursor: pointer
  &.is-setting-as-read
    .notification-item-content__status
      &--mark
        background-color: $support_lightgray !important
</style>
